import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Bill_item } from '../models/accounting/bill_item';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class ConvenienceFeeService {

  constructor(private http: HttpClient) { }

  get(entry_id: string, charge_amount: Number): Promise<Bill_item | boolean> {
    return this.getWithRest('entry_id/' + entry_id + '/pending/true/charge_amount/' + charge_amount);
  }

  getForExistingEntry(entry_id: string, charge_amount: Number): Promise<Bill_item | boolean> {
    return this.getWithRest('entry_id/' + entry_id + '/pending/false/charge_amount/' + charge_amount);
  }

  private getWithRest(rest_url: string) : Promise<Bill_item | boolean> {
    return new Promise((resolve, reject) => {
      return this.http.get(AppSettings.API_ENDPOINT + 'accounting/convenience_fee/' + rest_url).subscribe((response:any) => {

        if(response.type == 'bill_item' && response.data){
          resolve(response.data);
        } else if(response.type == 'bill_item') {
          resolve(response.data);
        } else {
          reject(response);
        }

      },
        error_response => {
            if(error_response instanceof HttpErrorResponse){
              reject(error_response.error);
            }
            reject(error_response);
      });
    });
  }

}
